import { SvgIcon } from '@mui/material'

const SvgGroups = (props) => (
  <SvgIcon viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" name="SvgGroups" {...props}>
    <style>
      {
        '.groups_svg__st0{fill:#2ba1cf}.groups_svg__st1{fill:#66baed}.groups_svg__st3{fill:#d8d5d0}.groups_svg__st6{fill:#eab599}.groups_svg__st7{fill:#f6caae}.groups_svg__st8{fill:#3d4159}.groups_svg__st9{fill:#fff}.groups_svg__st10{fill:#bfd5de}.groups_svg__st12{fill:#d3a489}.groups_svg__st13{fill:#bf8e75}.groups_svg__st14{fill:#2a2f4f}'
      }
    </style>
    <path
      className="groups_svg__st0"
      d="M25.741 41.527v21.86a31.672 31.672 0 01-10.299-4.001 32.166 32.166 0 01-8.975-8.094 31.909 31.909 0 01-3.722-6.306v-3.458a8.673 8.673 0 018.672-8.672h5.649a8.642 8.642 0 012.239.291l.008.002a8.601 8.601 0 012.693 1.25 8.654 8.654 0 013.735 7.128z"
    />
    <path
      className="groups_svg__st1"
      d="M25.741 41.527v21.86a31.672 31.672 0 01-10.299-4.001 32.166 32.166 0 01-8.975-8.094v-9.765a8.673 8.673 0 018.672-8.672h1.926a8.642 8.642 0 012.239.291l.008.002a8.601 8.601 0 012.693 1.25 8.656 8.656 0 013.736 7.129z"
    />
    <path
      d="M19.335 33.05l-.021.098-2.594 12.068c-.249 1.16-1.27 2-2.455 2.001h-.044a2.524 2.524 0 01-2.455-2.001L9.171 33.149l-.021-.099h10.185z"
      fill="#f2f0ec"
    />
    <path
      className="groups_svg__st3"
      d="M14.243 36.405l-3.905 2.17L9.15 33.05l2.426-1.429M14.243 36.405l3.905 2.17 1.188-5.525-2.426-1.429"
    />
    <path
      d="M2.584 30.764v-13.08c0-1.329.222-2.631.659-3.871A11.674 11.674 0 0116.06 6.165a11.656 11.656 0 019.843 11.518v13.08"
      fill="#cc7a3b"
    />
    <path
      d="M7.38 18.194c0 4.626 2.709 9.979 4.197 12.569H2.584v-13.08c0-1.329.222-2.631.659-3.871a11.673 11.673 0 0110.915-7.787c-3.584.089-6.778 5.84-6.778 12.169z"
      fill="#a35418"
    />
    <path
      className="groups_svg__st6"
      d="M17.338 29.513v3.798a3.096 3.096 0 01-3.095 3.094 3.094 3.094 0 01-3.094-3.094v-3.798h6.189z"
    />
    <path
      className="groups_svg__st7"
      d="M17.338 33.07v.241c0 1.39-.917 2.565-2.179 2.956a3.093 3.093 0 01-2.154-2.553 10.566 10.566 0 002.341-.119 10.496 10.496 0 001.992-.525zM5.755 23.29a2.877 2.877 0 11-5.754.002 2.877 2.877 0 015.754-.002z"
    />
    <path
      className="groups_svg__st6"
      d="M5.755 23.29a2.877 2.877 0 01-2.417 2.841 10.692 10.692 0 01-.382-2.841c0-.983.133-1.936.382-2.84a2.875 2.875 0 012.417 2.84z"
    />
    <path className="groups_svg__st6" d="M3.906 23.29a1.029 1.029 0 11-2.057 0 1.029 1.029 0 012.057 0z" />
    <path
      className="groups_svg__st6"
      d="M21.632 19.615v9.892a10.672 10.672 0 01-5.67 2.822l-.053.009c-.542.086-1.098.129-1.666.129-5.913 0-10.706-4.793-10.706-10.706v-4.077c0-.522.037-1.036.109-1.538 2.547 1.832 6.2 1.651 8.527-.548a6.064 6.064 0 001.609-2.514c.168 1.61.905 3.177 2.21 4.411 1.554 1.466 3.607 2.173 5.64 2.12z"
    />
    <path
      className="groups_svg__st7"
      d="M21.632 19.615v9.892a10.672 10.672 0 01-5.67 2.822l-.053.009c-5.121-.8-9.038-5.232-9.038-10.577v-4.077c0-.108.002-.216.006-.324 1.888.193 3.849-.394 5.296-1.763a6.064 6.064 0 001.609-2.514c.168 1.61.905 3.177 2.21 4.411 1.554 1.467 3.607 2.174 5.64 2.121z"
    />
    <path
      className="groups_svg__st6"
      d="M19.994 20.856a1.778 1.778 0 10-3.556 0M12.051 20.856a1.778 1.778 0 10-3.556 0"
    />
    <path
      className="groups_svg__st8"
      d="M11.488 21.613a1.215 1.215 0 11-2.43 0 1.215 1.215 0 012.43 0zM19.43 21.613a1.214 1.214 0 11-2.428.002 1.214 1.214 0 012.428-.002z"
    />
    <path
      className="groups_svg__st6"
      d="M15.459 24.671H13.03a.524.524 0 110-1.048h2.429a.524.524 0 010 1.048zM14.244 27.986a5.414 5.414 0 01-2.61-.674.476.476 0 01.459-.834 4.442 4.442 0 004.303 0 .477.477 0 01.459.834 5.407 5.407 0 01-2.611.674z"
    />
    <path
      className="groups_svg__st9"
      d="M11.24 21.399a.52.52 0 11-1.041 0 .52.52 0 011.041 0zM19.242 21.399a.52.52 0 11-1.04.001.52.52 0 011.04-.001z"
    />
    <path
      className="groups_svg__st6"
      d="M21.531 24.572a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0zM9.624 24.572a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z"
    />
    <path
      className="groups_svg__st10"
      d="M61.128 41.263v4.006a32.124 32.124 0 01-15.564 15.723 31.56 31.56 0 01-3.861 1.508 31.396 31.396 0 01-4.613 1.096l-.021.003V41.263a9.071 9.071 0 019.074-9.072h5.909c.699 0 1.379.077 2.032.227 4.033.922 7.044 4.534 7.044 8.845z"
    />
    <path
      d="M61.128 41.263v4.006a32.124 32.124 0 01-15.564 15.723 31.56 31.56 0 01-3.861 1.508V41.263c0-5.01 4.063-9.072 9.075-9.072h1.274c5.014 0 9.076 4.062 9.076 9.072z"
      fill="#dde8ed"
    />
    <path className="groups_svg__st12" d="M40.217 22.183a3.01 3.01 0 11-6.02.001 3.01 3.01 0 016.02-.001z" />
    <path
      className="groups_svg__st13"
      d="M40.217 22.183a3.01 3.01 0 01-2.528 2.972 11.208 11.208 0 01-.399-2.972c0-1.028.139-2.025.399-2.972a3.012 3.012 0 012.528 2.972z"
    />
    <path className="groups_svg__st13" d="M38.282 22.183a1.076 1.076 0 11-2.153 0 1.076 1.076 0 012.153 0z" />
    <path
      className="groups_svg__st10"
      d="M49.097 35.905l-4.085 2.271-1.243-5.781 2.538-1.495M49.097 35.905l4.085 2.271 1.243-5.781-2.539-1.495"
    />
    <path className="groups_svg__st12" d="M57.979 22.183a3.01 3.01 0 106.02.001 3.01 3.01 0 00-6.02-.001z" />
    <path
      className="groups_svg__st13"
      d="M57.979 22.183a3.01 3.01 0 002.528 2.972c.261-.947.399-1.943.399-2.972 0-1.028-.139-2.025-.399-2.972a3.011 3.011 0 00-2.528 2.972z"
    />
    <path className="groups_svg__st13" d="M62.065 22.183a1.076 1.076 0 11-2.153 0 1.076 1.076 0 012.153 0z" />
    <path
      className="groups_svg__st13"
      d="M60.3 20.583c0 5.574-4.072 10.199-9.404 11.057-.584.096-1.185.145-1.798.145-6.187 0-11.202-5.015-11.202-11.202 0-2.927 1.017-7.322 2.855-9.317 2.047-2.222 5.087-1.885 8.347-1.885.613 0 1.213.049 1.798.145 5.332.858 9.404 5.482 9.404 11.057z"
    />
    <path
      className="groups_svg__st13"
      d="M52.335 28.695v3.973a3.236 3.236 0 01-3.238 3.237 3.237 3.237 0 01-3.237-3.237v-3.973h6.475z"
    />
    <path
      className="groups_svg__st12"
      d="M52.335 32.416v.252a3.236 3.236 0 01-2.28 3.092 3.234 3.234 0 01-2.253-2.671 11.101 11.101 0 002.45-.125 10.87 10.87 0 002.083-.548zM60.3 20.583c0 5.574-4.072 10.199-9.404 11.057-5.332-.858-9.404-5.483-9.404-11.057 0-3.433 1.544-6.505 3.976-8.56a11.158 11.158 0 015.428-2.498c4.971.8 8.848 4.875 9.349 9.94.036.368.055.742.055 1.118z"
    />
    <path
      className="groups_svg__st13"
      d="M49.098 26.1a5.662 5.662 0 01-2.731-.705.498.498 0 11.48-.873 4.655 4.655 0 004.502 0 .497.497 0 11.48.873 5.662 5.662 0 01-2.731.705z"
    />
    <path
      className="groups_svg__st8"
      d="M46.712 19.931a1.27 1.27 0 11-2.542 0 1.27 1.27 0 012.542 0zM54.025 19.931a1.27 1.27 0 11-2.542 0 1.27 1.27 0 012.542 0z"
    />
    <path
      className="groups_svg__st9"
      d="M46.453 19.707a.545.545 0 11-1.09 0 .545.545 0 011.09 0zM53.828 19.707a.545.545 0 11-1.09 0 .545.545 0 011.09 0z"
    />
    <path className="groups_svg__st13" d="M50.369 23.13h-2.542a.548.548 0 010-1.096h2.542a.548.548 0 110 1.096z" />
    <path className="groups_svg__st10" d="M52.786 40.966h4.883v1.495h-4.883v-1.495z" />
    <path
      className="groups_svg__st14"
      d="M48.442 6.181a6.79 6.79 0 016.291 6.434l.032.648h1.952l1.051 6.991 2.546-.788-.342-6.851a6.79 6.79 0 00-6.807-6.452l-4.723.018z"
    />
    <path className="groups_svg__st8" d="M59.757 3.477a6.92 6.92 0 01-9.786 9.786l9.786-9.786z" />
    <path
      className="groups_svg__st8"
      d="M49.972 13.263H41.48l-1.052 6.992-2.546-.788.341-6.851a6.79 6.79 0 016.807-6.452l12.265.046 1.622 2.918"
    />
    <path
      className="groups_svg__st14"
      d="M49.753 6.181a6.79 6.79 0 00-6.291 6.434l-.032.648h-1.952l-1.052 6.991-2.546-.788.342-6.851a6.79 6.79 0 016.807-6.452l4.724.018z"
    />
    <path
      className="groups_svg__st8"
      d="M45.564 58.593v2.399C41.446 62.921 36.85 64 32 64s-9.447-1.079-13.565-3.009v-2.398c0-4.735 3.214-8.717 7.581-9.885a9.715 9.715 0 011.814-.314c.277-.022.555-.034.837-.034h6.664a10.277 10.277 0 012.642.343l.009.002c1.152.308 2.225.812 3.177 1.475a10.219 10.219 0 014.405 8.413z"
    />
    <path
      className="groups_svg__st1"
      d="M38.007 48.59l-.025.116-3.264 15.179A33.676 33.676 0 0132 64a30.83 30.83 0 01-2.211-.078c-.171-.012-.341-.023-.511-.038l-3.263-15.177-.024-.118h12.016z"
    />
    <path
      className="groups_svg__st0"
      d="M31.999 52.549l-4.607 2.56-1.401-6.518 2.862-1.686M31.999 52.549l4.606 2.56 1.401-6.518-2.862-1.686"
    />
    <path
      className="groups_svg__st6"
      d="M35.65 44.419v4.48a3.65 3.65 0 01-3.652 3.65 3.65 3.65 0 01-3.65-3.65v-4.48h7.302z"
    />
    <path
      className="groups_svg__st7"
      d="M35.65 48.615v.284a3.652 3.652 0 01-2.571 3.487 3.652 3.652 0 01-2.542-3.012 12.526 12.526 0 002.762-.141 12.276 12.276 0 002.351-.618zM21.984 37.076a3.397 3.397 0 01-3.395 3.395 3.396 3.396 0 113.395-3.395z"
    />
    <path
      className="groups_svg__st6"
      d="M21.984 37.076a3.397 3.397 0 01-2.852 3.352 12.654 12.654 0 01-.45-3.352c0-1.16.157-2.284.45-3.352a3.396 3.396 0 012.852 3.352z"
    />
    <path className="groups_svg__st6" d="M19.803 37.076a1.213 1.213 0 11-2.426 0 1.213 1.213 0 012.426 0z" />
    <path className="groups_svg__st7" d="M42.013 37.076a3.397 3.397 0 003.395 3.395 3.396 3.396 0 10-3.395-3.395z" />
    <path
      className="groups_svg__st6"
      d="M42.013 37.076a3.397 3.397 0 002.852 3.352c.293-1.068.45-2.192.45-3.352 0-1.16-.157-2.284-.45-3.352a3.397 3.397 0 00-2.852 3.352z"
    />
    <path
      className="groups_svg__st6"
      d="M44.631 30.462v4.81c0 6.286-4.592 11.5-10.605 12.468l-.062.01c-.64.103-1.296.153-1.966.153-6.976 0-12.631-5.655-12.631-12.631v-4.811c0-1.469.25-2.88.713-4.192 1.728-4.916 6.412-8.44 11.917-8.44H32c.669 0 1.326.052 1.967.153 6.041.944 10.664 6.173 10.664 12.48z"
    />
    <path className="groups_svg__st6" d="M46.622 37.076a1.213 1.213 0 11-2.426 0 1.213 1.213 0 012.426 0z" />
    <path
      className="groups_svg__st7"
      d="M44.63 30.462v4.81c0 6.286-4.592 11.5-10.604 12.468l-.062.01c-6.042-.944-10.663-6.172-10.663-12.479v-4.81c0-6.307 4.623-11.536 10.666-12.479 6.041.944 10.663 6.173 10.663 12.48z"
    />
    <path
      className="groups_svg__st8"
      d="M29.309 34.536a1.433 1.433 0 11-2.866 0 1.433 1.433 0 012.866 0zM37.555 34.536a1.433 1.433 0 11-2.866 0 1.433 1.433 0 012.866 0z"
    />
    <path
      className="groups_svg__st9"
      d="M29.017 34.284a.614.614 0 11-1.228 0 .614.614 0 011.228 0zM37.333 34.284a.614.614 0 11-1.228 0 .614.614 0 011.228 0z"
    />
    <path
      className="groups_svg__st6"
      d="M33.432 37.583h-2.866a.618.618 0 010-1.236h2.866a.618.618 0 110 1.236zM31.999 41.493a6.385 6.385 0 01-3.08-.795.561.561 0 11.541-.985 5.241 5.241 0 005.076 0 .562.562 0 01.541.985c-.963.53-2.02.795-3.078.795z"
    />
    <path
      className="groups_svg__st14"
      d="M44.631 26.097v4.927H42.28v-3.859l-16.971-3.153-3.591-.667v7.68h-2.351v-4.928c0-5.617 4.553-10.17 10.169-10.17h4.926c.134 0 .268.002.401.009 5.429.209 9.768 4.677 9.768 10.161z"
    />
    <path
      className="groups_svg__st8"
      d="M44.631 26.097v4.927H42.28v-3.859l-16.971-3.153c.935-4.491 4.832-7.894 9.554-8.076 5.429.209 9.768 4.677 9.768 10.161z"
    />
  </SvgIcon>
)

export default SvgGroups
